import { Fragment, useLayoutEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DraftBookCard } from "../shared/DraftBookCard";
import PlusIcon from "../assets/images/plus_icon.svg";
import { useDispatch } from "react-redux";
import { getDraftBooks } from "../Store/api/classApi";

export const DraftBooks = () => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [books, setBooks] = useState([]);
  const [totalBooks, setTotalBooks] = useState(0);
  const storedBookId = localStorage.getItem("lastBookId");

  useLayoutEffect(() => {
    dispatch(
      getDraftBooks({
        page,
        onSuccess: (res) => {
          const { pagination: { totalItems = 0 } = {}, data = [] } = res;
          setBooks((prev) => [...prev, ...data]);
          page === 1 && setTotalBooks(totalItems);
        },
      })
    );
  }, [page, dispatch]);

  const handleClick = () => setPage((prev) => prev + 1);

  return (
    <div
      className="book_shelf_draft_container activities_wrap border-grey"
      style={{ padding: "20px 15px 20px 30px" }}
    >
      <h4 className="book_shelf_draft_title">Drafts</h4>
      <div
        className={`book_shelf_draft_parent ${
          totalBooks > 7
            ? "book_shelf_draft_parent_more overflow-auto"
            : "book_shelf_draft_parent_less"
        }`}
      >
        <div
          ref={ref}
          id="draft_container"
          className="book_shelf_draft_card_container"
        >
          <div className="book_shelf_draft_card_with_icon">
            <img
              className="cursor"
              src={PlusIcon}
              alt="plus_dark"
              width={40}
              height={40}
              onClick={() => navigate(`/create/${storedBookId}?openModel=true`)}
            />
          </div>
          {books.map((item, index) => (
            <Fragment key={index}>
              <DraftBookCard {...item} />
            </Fragment>
          ))}
        </div>
      </div>
      <div className="book_shelf_draft_footer">
        <h4 className="book_shelf_footer_text m-0">{`${totalBooks} DRAFTS`}</h4>
        <div className="d-flex gap-4 align-items-center">
          <button
            className="cursor save-btn text-decoration-none fw-500 fs-14"
            disabled={totalBooks <= 7 || totalBooks === books.length}
            onClick={handleClick}
          >
            Load More
          </button>
        </div>
      </div>
    </div>
  );
};
